/* eslint-disable no-restricted-syntax */
/* eslint-disable no-multi-assign */
/* eslint-disable guard-for-in */
import _ from 'lodash';
import get from 'lodash/get';
import * as actionTypes from './Actions';
import * as designDataReduerActions from '@configuratorware/configurator-frontendgui/App/Reducers/DesignData/Actions';

const initialState = {
  designerOptionRefs: [],
  designerMobileProductsListOpen: false,
  designerMobileModalContent: null,
  designerMobileModalContentOptions: {
    RENDER_OVERVIEW: 'RENDER_OVERVIEW',
    RENDER_ITEMMENU: 'RENDER_ITEMMENU',
    RENDER_EDITGRAPHICS: 'RENDER_EDITGRAPHICS',
    RENDER_EDITTEXT: 'RENDER_EDITTEXT',
  },
  initialDesignData: {}
};

function CustomReducer(state = initialState, action = {}) {
  switch (action.type) {
    case designDataReduerActions.actionTypes.SET_INITIAL_DESIGN_DATA:{
      return {
        ...state,
        initialDesignData: action.initialDesignData,
      };
    }
    case actionTypes.SET_DESIGNER_OPTION_REF: {
      const selectedOptionsRefs = 'designerOptionRefs';
      const selected = get(state, selectedOptionsRefs, {}) || [];
      const idx = selected.findIndex((s) => s.identifier === action.identifier);
      let newOptionsRefs = [];
      if (idx < 0) newOptionsRefs = [...selected, { identifier: action.identifier, value: action.value }];
      else {
        newOptionsRefs = [...selected];
        newOptionsRefs[idx] = { identifier: action.identifier, value: action.value };
      }
      return {
        ...state,
        designerOptionRefs: newOptionsRefs,
      };
    }
    case actionTypes.SET_DESIGNER_MOBILE_PRODUCTLIST_OPEN: {
      return {
        ...state,
        designerMobileProductsListOpen: action.value,
      };
    }
    case actionTypes.SET_DESIGNER_MOBILE_MODAL_CONTENT: {
      let val = action.value;
      if (!state.designerMobileModalContentOptions[val]) val = null;
      return {
        ...state,
        designerMobileModalContent: val,
      };
    }
    default: {
      return state;
    }
  }
}
export default CustomReducer;
